import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appBarHeight } from "@/components/@common/AppBar/AppBar";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Button } from "@bookips/sds";
import Link from "next/link";
import { useEffect, useRef } from "react";
import CategoryHeader from "./components/CategoryHeader";
import CategorySectionComponent from "./components/CategorySection";
import ShortcutList from "./components/ShortcutList";
import SubjectList from "./components/SubjectList";
import { useCategoryMenu } from "./hooks/useCategoryMenu";
const CategoryMenuMobile = ()=>{
    const { isOpen , selectedMenuId , menus , selectedMenu , categoryColumns , menuFooter , handleSubjectClick , handleItemClick , handleClose  } = useCategoryMenu();
    // 카테고리 리스트 스크롤 컨테이너 ref
    const categoryScrollRef = useRef(null);
    // 과목 변경 시 스크롤 최상단으로 리셋
    useEffect(()=>{
        if (categoryScrollRef.current) {
            categoryScrollRef.current.scrollTop = 0;
        }
    }, [
        selectedMenuId
    ]);
    const content = /*#__PURE__*/ _jsxs("div", {
        className: cn("fixed inset-0 bg-white flex flex-col category-menu-portal", isOpen ? "z-side-menu" : "-z-10 pointer-events-none"),
        style: {
            paddingBottom: appBarHeight
        },
        children: [
            /*#__PURE__*/ _jsx(CategoryHeader, {
                onClose: handleClose
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex-1 flex min-h-0 overflow-hidden",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "w-[80px] max-w-[80px] shrink-0 h-full overflow-y-auto bg-gray-50 flex items-center",
                        children: /*#__PURE__*/ _jsx(SubjectList, {
                            items: menus,
                            selectedId: selectedMenuId,
                            onItemClick: handleSubjectClick,
                            variant: "mobile"
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        ref: categoryScrollRef,
                        className: "flex-1 flex flex-col min-w-0 h-full overflow-y-auto custom-scrollbar",
                        children: [
                            (selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.ctaButtonUrl) && (selectedMenu === null || selectedMenu === void 0 ? void 0 : selectedMenu.ctaButtonTitle) && /*#__PURE__*/ _jsx("div", {
                                className: "px-5 py-3 shrink-0",
                                children: /*#__PURE__*/ _jsx(Link, {
                                    href: selectedMenu.ctaButtonUrl,
                                    onClick: ()=>{
                                        mixpanelEvent("Category Board Item Clicked", {
                                            "Item Type": "CTA Button",
                                            "Item Name": selectedMenu.ctaButtonTitle
                                        });
                                        handleClose();
                                    },
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        variant: "stroke",
                                        color: "secondary",
                                        size: "md",
                                        className: "w-full",
                                        children: selectedMenu.ctaButtonTitle
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex-1",
                                children: categoryColumns.map((section, sectionIndex)=>/*#__PURE__*/ _jsx("div", {
                                        children: section.groups.map((group, groupIndex)=>{
                                            const isLastSection = sectionIndex === categoryColumns.length - 1;
                                            const isLastGroup = groupIndex === section.groups.length - 1;
                                            const isLast = isLastSection && isLastGroup;
                                            return /*#__PURE__*/ _jsx(CategorySectionComponent, {
                                                title: group.groupTitle,
                                                titleLink: group.groupLink,
                                                items: group.items,
                                                onItemClick: handleItemClick,
                                                variant: "mobile",
                                                isLast: isLast
                                            }, group.groupSeq);
                                        })
                                    }, section.sectionNumber))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ShortcutList, {
                items: menuFooter,
                onItemClick: handleClose,
                variant: "mobile"
            })
        ]
    });
    return content;
};
export default CategoryMenuMobile;
